import styled from 'styled-components';

export const StyledAboutStatsSection = styled.div`
  .about-stats-section {
    width: 100%;
    padding: 80px 16px;
    background: linear-gradient(135deg, #1e1b4b 0%, #312e81 50%, #4c1d95 100%);

    &__inner {
      margin: 0 auto;
      max-width: 1200px;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 40px;

      @media (max-width: 900px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 500px) {
        grid-template-columns: 1fr;
      }
    }

    &__stat {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 8px;

      p {
        color: rgba(255, 255, 255, 0.7);
      }

      p:first-of-type {
        color: ${({ theme }) => theme.colors.white};
      }
    }

    &__stat-icon {
      width: 48px;
      height: 48px;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 8px;

      svg {
        font-size: 20px;
        color: ${({ theme }) => theme.colors.mainOrange};
      }
    }
  }
`;
